import { Button, createStyles, makeStyles, Typography } from '@material-ui/core';
import { FC, useState } from 'react';
import T from 'src/components/content-manager/translator/T';
import VideoPlayer from 'src/components/elements/video/VideoPlayer';
import { useAppMeta } from 'src/core/provider/AppMeta';
import VideoResource from 'src/entities/video/VideoResource';
import AccountDialog from '../../elements/AccountDialog';

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1),
        },
    })
);

export const PremiumInfoVideo: FC = () => {
    const classes = useStyles();
    const { selectedLanguageKey } = useAppMeta();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div className={classes.root}>
            <Button onClick={handleOpen} variant="contained">
                <T k="account.my_premium_program.more_info" />
            </Button>
            <Typography variant="label">
                <T k="account.my_premium_program.more_info_hint" options={{ minutes: 3 }} />
            </Typography>
            <AccountDialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                content={
                    <VideoPlayer resource={VideoResource.publicVideoResource('PREMIUM_PROGRAM', selectedLanguageKey)} />
                }
            />
        </div>
    );
};
